/*
 * @Author: yangyiming
 * @LastEditors: yang chenglin
 * @Description: 通用营销活动列表
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Table,
  Form,
  Input,
  Button,
  DatePicker,
  Select,
  Balloon,
  Dialog,
  Field,
  Loading,
} from '@alifd/next';
import { history } from 'ice';
import LzPagination from '@/components/common/LzPagination';
import styles from './index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import utils from '@/common/utils';
import LzNotice from '@/components/common/LzNotice';
import { Servlets } from '@/service';
import ExecuteLog from '../components/ExecuteLog';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';
import DeleteTask from '@/components/DeleteTask';

const rcordsTitle = (
  <div>
    <div
      style={{
        color: '#333333',
        fontSize: '14px',
        fontWeight: 500,
        marginBottom: '2px',
      }}
    >
      温馨提示：
    </div>
    <div
      style={{
        position: 'relative',
        top: '1px',
        color: '#657180',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.5,
      }}
    >
      1.
      使用短信功能，需要保证签名审核通过，商家可在工具箱中修改签名，签名审核时间为法定工作日18点官方统一审核
      <br />
      2. 短信发送时间范围为：早9:01-晚 19:59（日常）
      <br />
    </div>
  </div>
);

const BASEMODELID = 6;

const MarketingActivityList = (props) => {
  const { paramsFromView } = props;
  const Option = Select.Option;
  const [isLoading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  // 获取列表信息
  const [dataList, setDataList] = useState([]);
  const formField = Field.useField({
    values: {
      modelId: BASEMODELID,
    },
  });
  // const dataList = [{
  //   "payNum":11,
  //   "launchEndTime":198923324343,
  //   "launchTime":1989233243434,
  //   "campaignName":100,
  //   "campaignModel":2,
  //   "remark":"ewewe",
  //   "id":1
  //   }]
  // 获取详情列表信息
  const [detailsList, setDetailsList] = useState({});

  // 请求参数获取
  const [formSelect, setFormSelect] = useState({
    taskName: '',
    taskStatus: '',
    startTime: '',
    modelId: BASEMODELID,
    endTime: '',
    pageNo: 1,
    pageSize: 10,
  });
  // 搜索参数
  const [searchParams, setSearchParams] = useState({
    taskName: '',
    taskStatus: '',
    modelId: BASEMODELID,
    startTime: '',
    endTime: '',
  });
  // 查询
  const search = (values, errors) => {
    (formSelect.taskName = values.taskName ? values.taskName : ''),
      (formSelect.taskStatus = values.taskStatus
        ? values.taskStatus
        : ''),
      (formSelect.modelId = values.modelId ? values.modelId : ''),
      (formSelect.startTime =
        values.year && values.year[0] ? values.year[0]._d.getTime() : ''),
      (formSelect.endTime =
        values.year && values.year[0] ? values.year[1]._d.getTime() : ''),
      (formSelect.pageSize = pageInfo.pageSize);
    pageInfo.pageNo = 1;
    getCampaignList(formSelect);
    setSearchParams(formSelect);
  };
  // 活动状态
  const sendStateOption = [
    { label: '全部状态', value: '' },
    { label: '未开始', value: '0' },
    { label: '投放中', value: 1 },
    { label: '投放成功', value: 2 },
    { label: '投放异常', value: 3 },
    { label: '已停止', value: 4 },
  ];
  // 推送模型
  // const pushModel = [
  //   { label: '全部', value: '' },
  //   { label: '新会员首购模型', value: '新会员首购模型' },
  //   { label: '新会员开卡未购', value: '新会员开卡未购' },
  //   { label: '高潜入会会员', value: '高潜入会会员' }
  // ]
  const [pushModel, setPushModel] = useState([]);
  // 执行日志所需id
  const [excuteId, setExcuteId] = useState();
  // 执行日志所需 发送类型，根据类型判断是否有 操作 栏
  const [executeType, setExecuteType] = useState(1);
  // 执行日志弹窗是否显示
  const [executeLogVisible, setExecuteLogVisible] = useState(false);
  // 当前模型Id (用于不同的执行日志)
  const [currentCampaignModelId, setCurrentCampaignModelId] = useState();
  // 执行日志弹窗关闭
  const executeClose = () => {
    setExecuteLogVisible(false);
  };

  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 获得表格数据
  const getCampaignList = (params) => {
    setLoading(true);
    const param = {
      taskName: params.taskName,
      taskStatus: params.taskStatus,
      // modelId: params.modelId,
      // TODO: 为应付上线，后端接口并未按照源模型进行迁移，在查询处写死key
      taskType: BASEMODELID,
      startTime: params.startTime,
      endTime: params.endTime,
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      ...params,
    };
    Servlets('autoModemarketCampaign', param)
      .then((res) => {
        setDataList(res.data);
        setPageInfo({
          ...pageInfo,
          pageNo: res.page.pageNo,
          pageSize: res.page.pageSize,
          total: res.page.total,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
      });
  };

  // 翻页方法
  const handleTaskPageSizeChange = async (pages = {}) => {
    setLoading(true);
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      getCampaignList({
        pageSize: pages.pageSize,
        pageNo: pages.pageNo,
        taskName: searchParams.taskName,
        taskStatus: searchParams.taskStatus,
        startTime: searchParams.startTime,
        endTime: searchParams.endTime,
        modelId: searchParams.modelId,
      });
    } catch (e) {
      setLoading(false);
      parent.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      LzMsg.error(e.message);
    }
  };
  // 表格中停止
  const handleStop = (stopId) => {
    parent.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    Servlets('stopAutoModemarketCampaign', { id: stopId })
      .then((res) => {
        const tempParam = {
          ...formSelect,
          pageNo: pageInfo.pageNo,
          pageSize: pageInfo.pageSize,
        };
        getCampaignList(tempParam);
        LzMsg.success('停止成功');
        setStopVisible(false);
      })
      .catch(() => {
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        setStopVisible(false);
      });
  };
  // 停止
  const [stopVisible, setStopVisible] = useState(false);
  // 停止id
  const [stopId, setStopId] = useState();
  // 获取推送模型类型
  const getCampaignModelType = () => {
    setFormLoading(true);
    // Servlets('getCampaignModelType', {})
    //   .then((res) => {
        let tempList = [];
        // tempList.push({ modelId: 0, taskName: '全部' });
        // for (const value of res.data) {
        //   tempList.push(value);
        // }
        tempList.push({
          activityDescription: "通过客户在店铺内的实际下单情况，进行用户下一次购买时间预估，在预估时间点进行短信触达，提高客户复购率",
          taskName: "复购模型",
          applyPop: true,
          applySo: true,
          modelId: 6,
          modelType: 3001,
          productLevel: 1
        });
        setPushModel(tempList);
        if(paramsFromView) {
          formField.setValues({
            taskName:paramsFromView.taskName?paramsFromView.taskName:'',
            taskStatus:paramsFromView.taskStatus?paramsFromView.taskStatus:'',
            modelId:paramsFromView.modelId?paramsFromView.modelId:BASEMODELID,
            year:[
              paramsFromView.startTime?moment(paramsFromView.startTime):'',
              paramsFromView.startTime?moment(paramsFromView.endTime):''
            ]
          });
        }
        setFormLoading(false);
      // })
      // .catch(() => {
      //   parent.scrollTo(0, 0);
      //   document.documentElement.scrollTop = 0;
      //   setFormLoading(false);
      // });
  };
  // 表格中详情调接口
  const getTaskDetails = (visible, item) => {
    const params = {
      campaignId: item.id,
      modelId: item.taskType,
    };
    if (visible) {
      Servlets('getTaskDetails', params)
        .then((res) => {
          setDetailsList(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setDetailsList({});
    }
  };
  useEffect(() => {
    getCampaignModelType();
    getCampaignList(paramsFromView ? paramsFromView:{});
  }, []);
  const defaultTimeValues = [
    moment("00:00:00", "HH:mm:ss", true),
    moment("23:59:59", "HH:mm:ss", true)
  ];
  return (
    <div style={{ marginTop: '20px' }}>
      <div className={styles['light-blue-tipsbg']}>
        <LzNotice cotent={rcordsTitle} />
      </div>
      <div className={styles.content}>
      {/* <Loading visible={formLoading} style={{width:'100%'}}> */}
        <Form field={formField}>
          <div className="marketing-activity-list" style={{ display: 'flex' }}>
            <Form.Item className={styles.labelWidth}>
              <span className={styles.mr15}>活动名称：</span>
              <Input
                name="taskName"
                trim
                placeholder="请输入活动名称"
                style={{ width: '74%' }}
              />
            </Form.Item>
            <Form.Item hasFeedback className={styles.labelWidth}>
              <span className={styles.mr15}>创建时间：</span>
              <DatePicker.RangePicker
                placeholder={['开始时间', '结束时间']}
                popupAlign="tr tr"
                name="year"
                showTime={{ defaultValue: defaultTimeValues,format: 'HH:mm:ss' }}
                resetTime
                followTrigger
                popupContainer={(target) => target.parentNode}
                // onChange={(value) => {
                //   value[0] ? setFormSelect({ ...formSelect, startTime: value[0]._d.getTime() }) : ""
                //   value[1] ? setFormSelect({ ...formSelect, endTime: value[1]._d.getTime() }) : ""
                // }}
                style={{ width: '325px' }}
              />
            </Form.Item>
            <Form.Item className={styles.labelWidth}>
              <span className={styles.mr15}>活动状态：</span>
              <Select
                popupContainer={(triggerNode) => triggerNode.parentNode}
                className={styles.select}
                style={{ width: '74%', textAlign: 'left' }}
                dataSource={sendStateOption}
                name="taskStatus"
              />
            </Form.Item>
            <Form.Item className={styles.labelWidth} style={{ flex: 1 }}>
              <span className={styles.mr15}>推送模型：</span>
              <Select
                popupContainer={(triggerNode) => triggerNode.parentNode}
                style={{ width: '74%' }}
                name="modelId"
              >
                {pushModel.map((item, index) => {
                  return (
                    <Option value={item.modelId} key={index}>
                      {item.taskName}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: '1' }} />
            <Form.Item
              className={styles.labelWidth}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Form.Submit
                type="primary"
                className={`${styles.mr10} ${styles.w88}`}
                onClick={search}
              >
                查询
              </Form.Submit>
              <Form.Reset
                type="normal"
                className={styles.w88}
                onClick={() => {
                  // 重新请求
                  getCampaignList({
                    taskName: '',
                    taskStatus: '',
                    startTime: '',
                    endTime: '',
                    modelId: BASEMODELID,
                    pageNo: 1,
                    pageSize: 10,
                  });
                  setFormSelect({
                    taskName: '',
                    taskStatus: '',
                    startTime: '',
                    modelId: BASEMODELID,
                    endTime: '',
                    pageNo: 1,
                    pageSize: 10,
                  })
                  // 将查询参数清空
                  setSearchParams({
                    taskName: '',
                    taskStatus: '',
                    startTime: '',
                    endTime: '',
                    modelId: BASEMODELID,
                  });
                  // 将页码置为初始
                    setPageInfo({
                      ...pageInfo,
                      pageNo: 1,
                      pageSize: 10,
                    });
                  }}
                >
                  重置
                </Form.Reset>
              </Form.Item>
            </div>
          </Form>
        {/* </Loading> */}
        <Table
          className="marketing-activity-list"
          fixedHeader
          maxBodyHeight="906px"
          dataSource={dataList}
          loading={isLoading}
          style={{ marginTop: '10px' }}
        >
          <Table.Column
            title="创建时间"
            align="left"
            cell={(value, index, item) => (
              <div>
                <div className={styles.payNum}>
                  {moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')}
                </div>
              </div>
            )}
          />
          <Table.Column
            title="活动时间"
            width="15%"
            align="left"
            cell={(value, index, item) => (
              <div>
                <div className={styles.payNum}>
                  {'开始时间：'}
                  {moment(item.taskStartTime).format('YYYY-MM-DD')}
                </div>
                <div className={styles.payNum}>
                  {'结束时间：'}
                  {moment(item.taskEndTime).format('YYYY-MM-DD')}
                </div>
              </div>
            )}
          />
          <Table.Column
            title="活动名称"
            align="left"
            dataIndex="taskName"
          />
          <Table.Column
            title="推送模型"
            align="left"
            // cell={(value, index, item) => <div>{item.campaignModel}</div>}
            cell={(value, index, item) => <div>复购模型</div>}
          />
          <Table.Column
            title="已推送成功人数"
            align="left"
            cell={(value, index, record) => (
              <div>
                {record.successCounts === -1
                  ? '--'
                  : record.successCounts}
              </div>
            )}
          />
          <Table.Column
            width="10%"
            title="执行次数"
            align="left"
            cell={(value, index, item) => (
              <div>
                {item.cycleCounts ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '10px' }}>
                      {utils.numFormat(item.cycleCounts) || 0}
                    </span>
                    {/* <Tooltip align="t" alignEdge closable={false}
                        style={{ color: '#9ca7b6', paddingLeft: '5px' }} trigger={<Button type="primary" style={{ color: "#3399FF", marginRight: "10px" }} text >详情</Button>}>
                        <div>
                          <span>{item.cycleSucessNum}成功</span>
                          <span style={{ marginLeft: "15px" }}>{item.cycleFaildNum}失败</span>
                        </div>
                      </Tooltip > */}
                    <Balloon
                      align="t"
                      shouldUpdatePosition
                      closable={false}
                      onVisibleChange={(visible) => {
                        getTaskDetails(visible, item);
                      }}
                      trigger={
                        <Button
                          type="primary"
                          style={{ color: '#3399FF', marginRight: '10px' }}
                          text
                        >
                          详情
                        </Button>
                      }
                    >
                      <div key={index}>
                        任务：<span>{detailsList.successNum}成功</span>
                        <span style={{ marginLeft: '15px' }}>
                          {detailsList.failedNum}失败
                        </span>
                      </div>
                    </Balloon>
                  </div>
                ) : (
                  <div>0</div>
                )}
              </div>
            )}
          />
          <Table.Column
            title="状态"
            width="10%"
            align="left"
            cell={(value, index, item) => (
              <div>
                {item.taskStatus === 0 && (
                  <span style={{ color: '#C3CBD6' }}>未开始</span>
                )}
                {item.taskStatus === 1 && (
                  <span style={{ color: '#333333' }}>投放中</span>
                )}
                {item.taskStatus === 2 && (
                  <span style={{ color: '#00BB66' }}>投放成功</span>
                )}
                {item.taskStatus === 3 && (
                  <span style={{ color: '#FF3333' }}>投放异常</span>
                )}
                {item.taskStatus === 4 && (
                  <span style={{ color: '#FF9900' }}>已停止</span>
                )}
              </div>
            )}
          />
          <Table.Column
            width="14%"
            title="操作"
            align="left"
            cell={(value, index, item) => (
              <div>
                <Button
                  type="primary"
                  style={{ color: '#3399FF', marginLeft: '8px' }}
                  text
                  onClick={() => {
                    // // 宝洁
                    // if (item.taskType === 1) {
                    //   history.push(
                    //     '/smsautomarket/marketing/autoMarketing/daily/membership/notpurchase/create',
                    //     { checkType: 3, data: item, params: JSON.stringify({...searchParams,pageNo: pageInfo.pageNo, pageSize: pageInfo.pageSize})}
                    //   );
                    // } else if (item.taskType === 2) {
                    //   // 联合利华模型
                    //   history.push(
                    //     '/smsautomarket/marketing/automarket/member/first/purchase/create',
                    //     { checkType: 3, data: item, params: JSON.stringify({...searchParams,pageNo: pageInfo.pageNo, pageSize: pageInfo.pageSize}) }
                    //   );
                    // } else
                    if (item.taskType === 6) {
                      // 复购模型
                      history.push(
                        '/smsautomarket/marketing/cycleCreate',
                        { checkType: 3, data: item, params: JSON.stringify({...searchParams,pageNo: pageInfo.pageNo, pageSize: pageInfo.pageSize}) }
                      );
                    } else {
                      history.push('/smsautomarket/marketing/create', {
                        checkType: 3,
                        data: item,
                        params: JSON.stringify({...searchParams,pageNo: pageInfo.pageNo, pageSize: pageInfo.pageSize})
                      });
                    }
                  }}
                >
                  查看
                </Button>
                {
                  // 投放成功 投放异常 停止 的停止按钮置灰
                  item.taskStatus === 0 || item.taskStatus === 1 ? (
                    <Button
                      style={{ color: '#3399FF', marginLeft: '8px' }}
                      type="primary"
                      text
                      onClick={() => {
                        setStopId(item.id);
                        setStopVisible(true);
                      }}
                    >
                      停止
                    </Button>
                  ) : (
                    <Button disabled text style={{ marginLeft: '8px' }}>
                      停止
                    </Button>
                  )
                }
                <Button
                  type="primary"
                  style={{ color: '#3399FF', marginLeft: '8px' }}
                  text
                  onClick={() => {
                    // // 宝洁
                    // if (item.taskType === 1) {
                    //   history.push(
                    //     '/smsautomarket/marketing/autoMarketing/daily/membership/notpurchase/create',
                    //     { checkType: 2, data: {...item, formData: utils.replaceT(item.formData, 'smsContent')} }
                    //   );
                    // } else if (item.taskType === 2) {
                    //   // 联合利华模型
                    //   history.push(
                    //     '/smsautomarket/marketing/automarket/member/first/purchase/create',
                    //     { checkType: 2, data: {...item, formData: utils.replaceT(item.formData, 'smsContent')} }
                    //   );
                    // } else
                    if (item.taskType === 6) {
                      // 复购模型
                      history.push(
                        '/smsautomarket/marketing/cycleCreate',
                        { checkType: 2, data: { ...item } }
                      );
                    } else {
                      history.push('/smsautomarket/marketing/create', {
                        checkType: 2,
                        data: {...item },
                      });
                    }
                  }}
                >
                  复制
                </Button>
                {item.taskStatus === 0 ? (
                  <Button text disabled style={{ marginLeft: '8px' }}>
                    执行日志
                  </Button>
                ) : (
                  <Button
                    style={{ color: '#3399FF', marginLeft: '8px' }}
                    type="primary"
                    text
                    onClick={() => {
                      setExecuteLogVisible(true);
                      setExcuteId(item.id);
                      setExecuteType(item.smsType)
                      setCurrentCampaignModelId(item.taskType);
                    }}
                  >
                    执行日志
                  </Button>
                )}
                <DeleteTask
                  deleteIds={[item.id]}
                  deleteTaskApi={'deleteAutoModeMarketTask'}
                  refreshList={(v)=>{getCampaignList({...formSelect})}}
                  disabledFlag={!((item.taskStatus === 4 && item.successCounts===0) || (item.taskStatus === 3 && item.successCounts===0))}
                  boxStyle={{marginLeft: '8px'}}
                />
              </div>
            )}
          />
        </Table>
        <LzPagination pageInfo={pageInfo} onChange={handleTaskPageSizeChange} />
        {/* 执行日志 */}
        <Dialog
          title="执行日志"
          visible={executeLogVisible}
          isFullScreen
          shouldUpdatePosition
          // autoFocus={true}
          footer={false}
          style={{
            width: '1060px',
            minHeight: '445px'
          }}
          onClose={() => {
            setExecuteLogVisible(false);
          }}
        >
          <div style={{ margin: '30px 30px 15px 30px' }}>
            <ExecuteLog excuteId={excuteId} executeType={executeType}/>
            {/* 大于2的为普通模型的模型id */}
            {/* {
              currentCampaignModelId > 2 &&  excuteId  &&  <ExecuteLog excuteId={excuteId} />
            } */}
            {/* 宝洁模型Id 1 */}
            {/* {
              Number(currentCampaignModelId) === 1 &&  excuteId  &&  <ExecuteLogBaojie excuteId={excuteId} />
            } */}
            {/*  联合利华模型Id2  */}
            {/* {
              Number(currentCampaignModelId) ===2 && excuteId && <ExecuteLogLianhelihua excuteId={excuteId} />
            } */}
          </div>
        </Dialog>
        {/* Dialog:删除 */}
        <ConfirmDialog
          type="WARN"
          title="提示"
          promptInfo="即将停止任务，确认是否停止"
          flag={stopVisible}
          confirmHandel={() => {
            handleStop(stopId);
          }}
          cancelHandel={() => {
            setStopVisible(false);
            setStopId('');
          }}
        />
      </div>
    </div>
  );
};

export default MarketingActivityList;
